import { render } from "./product-addon-monogram.vue?vue&type=template&id=0182db7c&scoped=true&lang=pug"
import script from "./product-addon-monogram.vue?vue&type=script&lang=js"
export * from "./product-addon-monogram.vue?vue&type=script&lang=js"

import "./product-addon-monogram.vue?vue&type=style&index=0&id=0182db7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0182db7c"]])

export default __exports__